import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Twitter solves massive bug",
  "description": "",
  "published": "2008-10-13T00:00:00.000Z",
  "redirect_from": ["/blog/twitter-solves-massive-bug/swizec/57"],
  "categories": "blog, life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today I resolved a bug lurking deep within the workings of my `}<a parentName="p" {...{
        "href": "http://chlorineboards.swizec.com/"
      }}>{`Chlorine Boards framework`}</a>{` and I have `}<a parentName="p" {...{
        "href": "http://twitter.com"
      }}>{`twitter`}</a>{` to thank. When I made a blogpost about how `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/drug-use-is-not-abuse/2/374"
      }}>{`drug use is not abuse`}</a>{` a person following me on twitter immediatelly picked up on the post, gave it a read, retweeted and wanted to leave a comment. But couldn't. Immediately `}<a parentName="p" {...{
        "href": "http://twitter.com/OneLuvGurl"
      }}>{`@OneLuvGurl`}</a>{` tweeted to me about how she can't comment.`}</p>
    <p>{`We tweeted back and forth for about an hour about the issue when I finally just asked her to send me the comment and I'll see what I can do. It turned out that it was indeed, as I feared, the comment's fault. So I started poking around until I found what was wrong. The comment was too long ... but how can this be? The darn thing isn't very long at all.`}</p>
    <p>{`Two hours later I finally found out what the issue was and was able to resolve it. It would appear that three, or was it four, years ago I've made a terrible design flaw - I decided to use GET requests for ajax instead of POST requests. Since GET requests have a limited length this was naturally a disaster waiting to happen and I'm surprised the issue could go so long without being noticed, but I'm glad it's resolved and I've already updated all the websites running on Chlorine Boards with the surprisingly simple fix.`}</p>
    <p>{`This event just goes to show how much more than just status updates `}<a parentName="p" {...{
        "href": "http://twitter.com"
      }}>{`Twitter`}</a>{` has become and just how awful bugs can be.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      